import { produce } from 'immer'
import {
  RESET_DEACTIVATE_VIRTUAL_CARD_CONTENT,
  ResetDeactivateVirtualCardContentAction,
} from 'src/app/DeactivateVirtualCardContent/redux/deactivateVirtualCardContent.actions'
import {
  PUT_VIRTUAL_CARD_CANCEL_FAILURE,
  PUT_VIRTUAL_CARD_CANCEL_INIT,
  PUT_VIRTUAL_CARD_CANCEL_SUCCESS,
  PutVirtualCardCancelActions,
} from 'src/redux/actions/data/virtualCards.actions'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface DeactivateVirtualCardContentState {
  puttingVirtualCardCancel: boolean
  topLevelError?: string
  errorDetailMap?: ErrorDetailMap<string>
}

export const initialState: DeactivateVirtualCardContentState = {
  puttingVirtualCardCancel: false,
}

export type Actions =
  | PutVirtualCardCancelActions
  | ResetDeactivateVirtualCardContentAction

// Plain reducer — NOT the legacy `createFlyoutReducer`, which only ran the core
// reducer when the URL pathname matched `/virtualcards/:id/deactivate`. The
// overlay is now a query-param modal (`/virtualcards/:id?modal=deactivate`), so
// that path-gate never matched and the loading/error state went dead. The modal
// dispatches RESET on mount, so a re-opened modal never inherits the loading or
// error left by a previously-opened card; INIT clears prior error on retry and
// SUCCESS/FAILURE clear the loading flag.
const DeactivateVirtualCardContentReducer = (
  state = initialState,
  action: Actions,
): DeactivateVirtualCardContentState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case RESET_DEACTIVATE_VIRTUAL_CARD_CONTENT: {
        return initialState
      }

      case PUT_VIRTUAL_CARD_CANCEL_INIT: {
        draft.puttingVirtualCardCancel = true
        draft.topLevelError = undefined
        draft.errorDetailMap = undefined
        return draft
      }

      case PUT_VIRTUAL_CARD_CANCEL_FAILURE: {
        draft.puttingVirtualCardCancel = false
        const errors = parseBackendErrors(action.payload)
        draft.topLevelError = errors.topLevelError
        draft.errorDetailMap = errors.errorDetailMap
        return draft
      }

      case PUT_VIRTUAL_CARD_CANCEL_SUCCESS: {
        draft.puttingVirtualCardCancel = false
        return draft
      }
    }
  })
}

export default DeactivateVirtualCardContentReducer
